module.exports = __webpack_public_path__ + "img/flipkaart.23f6357b.png";